import client from '@stores/apollo'
import gql from 'graphql-tag'
import { IEmployeeImport } from '@api'
import { EmployeeImportFragment } from '@api/fragments'

interface IPayload {
  data: { node: IEmployeeImport }
}

export default function summary(id: string): Promise<IEmployeeImport> {
  return client.gql.query({ query, variables: { id } }).then(({ data: { node } }: IPayload) => node)
}

const query = gql`
  query node($id: ID!) {
    node(id: $id) {
      ... on EmployeeImport {
        ...EmployeeImportFragment
      }
    }
  }
  ${EmployeeImportFragment}
`
